'use strict';

var translations = {
    warnings: {
        straightRow: 'Evita filas de teclas consecutivas, como "asdf".',
        simpleRepeat: 'Evita palabras y caracteres repetidos, como "aaa" y "abcabc".',
        extendedRepeat: 'Evita palabras y caracteres repetidos, como "aaa" y "abcabc".',
        sequences: 'Evita secuencias como "abc" o "6543".',
        recentYears: 'Evita años recientes, como "2020".',
        dates: 'Evita fechas.',
        topTen: 'Evita contraseñas comunes.',
        topHundred: 'Evita contraseñas comunes.',
        common: 'Evita contraseñas comunes.',
        similarToCommon: 'Evita contraseñas comunes.',
        wordByItself: 'Evita usar una sola palabra.',
        namesByThemselves: 'No uses solo nombres y apellidos como contraseña.',
        commonNames: 'No uses solo nombres y apellidos como contraseña.',

        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: 'Usa un texto largo con más de dos palabras; evita frases comunes.',
        anotherWord: 'Añade una o dos palabras más. Usa mejor palabras poco comunes.',
        repeated: 'Evita palabras y caracteres repetidos, como "aaa" y "abcabc".',
        l33t: 'Evita sustituciones predecibles como "@" en lugar de "a" (como "cos@" en lugar de "cosa").',
        reverseWords: 'Evita palabras al revés, como "asac" (el revés de "casa").',
        allUppercase: 'Todo en mayúsculas es casi tan fácil de adivinar como todo en minúsculas.',
        dates: 'Evita fechas.',
        associatedYears: 'Evita fechas.',
        recentYears: 'Evita años recientes, como "2020".',
        sequences: 'Evita secuencias como "abc" o "6543".',

        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'menos de un segundo',
        second: '{base} segundo',
        seconds: '{base} segundos',
        minute: '{base} minuto',
        minutes: '{base} minutos',
        hour: '{base} hora',
        hours: '{base} horas',
        day: '{base} día',
        days: '{base} días',
        month: '{base} mes',
        months: '{base} meses',
        year: '{base} año',
        years: '{base} años',
        centuries: 'siglos',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
